export default (response) => {
    return response?.body?.forceLogIn || false;
};
